import axios from "axios";

export const NPL_API_BASE =
  process.env.REACT_APP_NPL_API_URL ||
  "https://roadsense-api-ox2oujtaaq-zf.a.run.app";

const nplApi = axios.create({
  baseURL: NPL_API_BASE,
});

export function fetchNplHourly(params) {
  const query = { _t: Date.now(), ...params };
  if (Array.isArray(query.locations)) {
    query.locations = query.locations.join(",");
  }
  return nplApi.get("/v1/temp/deviceTest/text/test", { params: query });
}

export function fetchNplOccupancy() {
  return nplApi.get("/v1/occupancy", { params: { org: "npl", _t: Date.now() } });
}

export default nplApi;
